import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

export type PostDataSecurityAccessAnomalyAlertsExportRequest = DynamicQueryParams;

export type PostDataSecurityAccessAnomalyAlertsExportResponse = { id: number };

export const postDataSecurityAccessAnomalyAlertsExportStart = createPostEndpoint<
	PostDataSecurityAccessAnomalyAlertsExportRequest,
	PostDataSecurityAccessAnomalyAlertsExportResponse
>('/api/v3/core/exports/access-anomaly/export/start');
